import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

type TripClassification = {
  value: string;
  label: string;
  applicableSpeedRules?: string[];
  exempt?: boolean;
  availableTo?: string[];
};

export function useTripClassifications() {
  const queryKey = ['tripClassifications'];
  const queryClient = useQueryClient();
  const query = useQuery<TripClassification[]>({
    queryKey,
    queryFn: ({ signal }) => {
      const json = [
        { $match: { name: 'tripClassification' } },
        {
          $project: {
            _id: false,
            value: true,
            label: true,
            applicableSpeedRules: true,
            exempt: true,
            availableTo: true,
          },
        },
        { $sort: { label: 1 } },
      ];

      return api.post('pipeline/options', { json, signal }).json();
    },
    placeholderData: (previousData) => previousData ?? [],
    staleTime: 1000 * 60 * 60 * 24,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
